import React from 'react';

import { ISiteMarker } from '@interfaces/map/map';

import styles from './MarkerShortInfo.module.scss';

interface IMarkerInfoProps {
	site: ISiteMarker;
	typeContainerMinWidth: string;
}

const SiteInfo = ({
	site,
	typeContainerMinWidth,
}: IMarkerInfoProps) => {
	const { siteType, siteId, lng, lat, vendor: { title: vendor } } = site;

	return (
		<>
			<div
				className={styles.type}
				style={{ minWidth: typeContainerMinWidth }}
			>
				{siteType.title}
			</div>
			<div className={styles.siteInfo}>
				<span className={styles.fieldName}>Site ID: </span>
				<span data-testid='site-id'>{siteId}</span>
			</div>
			<div className={styles.siteInfo}>
				<span className={styles.fieldName}>Latitude: </span>
				<span data-testid='site-lat'>{lat}</span>
			</div>
			<div className={styles.siteInfo}>
				<span className={styles.fieldName}>Longitude: </span>
				<span data-testid='site-lng'>{lng}</span>
			</div>
			<div className={styles.siteInfo}>
				<span className={styles.fieldName}>Vendor: </span>
				<span data-testid='site-vendor'>{vendor}</span>
			</div>
		</>
	);
};

export default SiteInfo;
